import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fd574c82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  fill: "#F3E7AB"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { ref, computed } from "vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import ListWithTooltips from "./table/ListWithTooltips.vue";

import {
  convertDateFromUTC,
  getPeriodStr,
  getOperandTypeName,
} from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import { formatNumber } from "@/services/utils/Strings";
import { SegmentFilter, Filters } from "@/services/segments/filters";
import { useSegmentsStore, Segment } from "@/store/segments/segments";
import { useSegmentsDictionariesStore } from "@/store/dictionaries/segments";
import { useRouter } from "vue-router";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentsTable',
  props: {
    segments: {},
    isArchiveEnabled: { type: Boolean },
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const segmentsStore = useSegmentsStore();
const segmentsDictionariesStore = useSegmentsDictionariesStore();
const router = useRouter();

let modifiedId = ref(0);
const confirmVisible = ref(false);
const blockedDeleteButton = ref(false);
const menu = ref();
const items = ref([
  {
    label: "Архивировать",
    icon: "pi pi-inbox",
    archive: "no_archive",
    command: () => {
      segmentsStore.archiveSegment(modifiedId.value).then(() => {
        emits("updateTable");
      });
    },
  },
  {
    label: "Разархивировать",
    icon: "pi pi-inbox",
    archive: "archive",
    command: () => {
      segmentsStore.unArchiveSegment(modifiedId.value).then(() => {
        emits("updateTable");
      });
    },
  },
  {
    label: "Дублировать",
    icon: "pi pi-copy",
    archive: "no_archive",
    command: () => {
      segmentsStore.duplicatedSegmentId = modifiedId.value;
      router.push({ name: "segmentCreate" });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) =>
    props.isArchiveEnabled
      ? ["both", "archive"].includes(item.archive)
      : ["both", "no_archive"].includes(item.archive)
  );
});

function getPeriod(filter: Filters) {
  const segmentFilter = new SegmentFilter(filter);
  const operands = segmentFilter.findDateOperands();
  return getPeriodStr(operands);
}

function getPeriodType(filter: Filters) {
  const segmentFilter = new SegmentFilter(filter);
  const operands = segmentFilter.findDateOperands();
  return getOperandTypeName(operands);
}

function getGenderData(filter: Filters) {
  const segmentFilter = new SegmentFilter(filter);
  const operands = segmentFilter.findGenderOperands();

  if (operands.length === 0) {
    return [];
  }

  // Объединяем все значения пола из всех операндов
  const allGenderValues: number[] = [];
  operands.forEach((operand) => {
    if (Array.isArray(operand.value)) {
      allGenderValues.push(...operand.value);
    }
  });

  // Преобразуем в формат для ListWithTooltips
  return allGenderValues
    .map((val) => ({
      id: val,
      name: val === 0 ? "М" : val === 1 ? "Ж" : "",
    }))
    .filter((item) => item.name !== "");
}

const toggle = (segmentId: number, event: any) => {
  modifiedId.value = segmentId;
  menu.value.toggle(event);
};

const deleteSegment = () => {
  blockedDeleteButton.value = true;
  segmentsStore
    .deleteSegment(modifiedId.value)
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    })
    .finally(() => {
      emits("updateTable");
      blockedDeleteButton.value = false;
      confirmVisible.value = false;
    });
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.segments,
      class: _normalizeClass([[
      _ctx.segments.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table main-table"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      resizableColumns: "",
      columnResizeMode: "expand"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"width":"38px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название",
          sortable: "",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'segment', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"max-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser__lname",
          header: "Автор",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "rich",
          header: "Охват"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.rich)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(formatNumber)(slotProps.data.rich.rich)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cost",
          header: "Стоимость"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.rich && slotProps.data.rich.cost)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(formatNumber)(slotProps.data.rich.cost / 100)) + " ₽ ", 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "—"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Тип периода",
          style: {"max-width":"183px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(getPeriodType(slotProps.data.filter)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "period",
          header: "Период",
          style: {"max-width":"183px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(getPeriod(slotProps.data.filter)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "brand",
          header: "Бренд",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: slotProps.data.brands,
              items: "brands",
              "item-key": "brand_pk",
              "item-value": "brand_name"
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "category",
          header: "Категория",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: slotProps.data.categories,
              items: "categories",
              "item-key": "id",
              "item-value": "full_name"
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "shop",
          header: "Магазин",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: slotProps.data.shops,
              items: "shops",
              "item-key": "id",
              "item-value": "shop_name"
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "gender",
          header: "Пол",
          style: {"max-width":"80px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: getGenderData(slotProps.data.filter),
              items: "genders",
              "item-key": "id",
              "item-value": "name",
              "show-tooltip": false
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "age",
          header: "Возраст",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: slotProps.data.ages,
              items: "ages",
              "item-key": "id",
              "item-value": "type"
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "state",
          header: "Статус"
        }, {
          body: _withCtx((slotProps) => [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(slotProps.data.state),
              xmlns: "http://www.w3.org/2000/svg",
              width: "8",
              height: "8",
              viewBox: "0 0 8 8",
              fill: "none"
            }, _hoisted_5, 2)),
            _createTextVNode(" " + _toDisplayString(_unref(segmentsDictionariesStore).statesMap.get(slotProps.data.state)?.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "type",
          header: "Тип сегмента"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(segmentsDictionariesStore).typesMap.get(slotProps.data.type)?.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_8, 8, _hoisted_6)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      visible: confirmVisible.value,
      "deleted-name": "сегмент",
      blocked: blockedDeleteButton.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmVisible.value = false)),
      onDelete: deleteSegment
    }, null, 8, ["visible", "blocked"])
  ], 64))
}
}

})